import { useState, useCallback, ReactNode } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import './LazyImage.scss';

interface LazyImageProps {
    src: string;
    alt: string;
    placeholder?: ReactNode;
}

const LazyImage: FCX<LazyImageProps> = ({
    src,
    alt,
    placeholder,
    className,
    style,
    testId,
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleLoad = useCallback(() => {
        setIsLoaded(true);
    }, []);

    const handleError = useCallback(() => {
        setHasError(true);
        setIsLoaded(true);
    }, []);

    return (
        <div
            className={cn("LazyImage", className, {
                "LazyImage--loaded": isLoaded,
                "LazyImage--error": hasError,
            })}
            style={style}
            data-testid={testId}
        >
            {(!isLoaded || hasError) && placeholder && (
                <div className="LazyImage__placeholder">
                    {placeholder}
                </div>
            )}
            <img
                src={src}
                alt={alt}
                className="LazyImage__img"
                onLoad={handleLoad}
                onError={handleError}
            />
        </div>
    );
};

export default LazyImage;
